import { render } from "./LoanApps.vue?vue&type=template&id=035a21d6"
import script from "./LoanApps.vue?vue&type=script&lang=js"
export * from "./LoanApps.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__